import React, { useEffect, useState } from 'react'
import Dashboardnavbar from '../../layout/Dashboardnavbar';
import Consultant from './Consultant';
import WorkStat from './WorkStat';
import axios from 'axios';
import { BASE_URL } from '../../config/axios';
import { toast } from 'react-toastify';
import { AddWorkStat } from './WorkStatCRUD';
import { AddWorkType } from './WorkTypesCRUD';
import { AddConsultant } from './ConsultantCrud';
import { WorkTypes } from './WorkTypes';

const ConsultantManagement = () => {
    const [activeTab, setActiveTab] = useState('sectors');

    const [subConsultantList, setSubConsultantList] = useState([]);
    const [workStatList, setWorkstatList] = useState([]);
    const [workTypeList, setWorkTypeList] = useState([]);
    const [buffering, setBuffering] = useState(false);
    const [bufferingForWorkStat, setBufferingForWorkStat] = useState(false);
    const [bufferingForWorkType, setBufferingForWorkType] = useState(false);

    const getSubConsultantData = async () => {
        try {
            setBuffering(true);
            const res = await axios.get(`${BASE_URL}/dpr/subconsultant/`);
            setSubConsultantList(res.data);
        } catch (error) {
            toast.error(error);
        } finally {
            setBuffering(false);
        }
    };

    const getWorkStatsData = async () => {
        try {
            setBufferingForWorkStat(true);
            const res = await axios.get(`${BASE_URL}/dpr/workstats/`);
            setWorkstatList(res.data);
        } catch (error) {
            toast.error(error);
        } finally {
            setBufferingForWorkStat(false);
        }
    };

    const getWorkTypeData = async () => {
        try {
            setBufferingForWorkType(true);
            const res = await axios.get(`${BASE_URL}/dpr/worktype/`);
            setWorkTypeList(res.data);
        } catch (error) {
            toast.error(error);
        } finally {
            setBufferingForWorkType(false);
        }
    };

    useEffect(() => {
        getSubConsultantData();
        getWorkStatsData();
        getWorkTypeData();
    }, []);

    const tabs = [
        { key: 'sectors', label: 'Sector Details' },
        { key: 'workstages', label: 'Work Stages' },
        { key: 'worktypes', label: 'Work Types' },
    ];

    const addButtonMap = {
        sectors: <AddConsultant getSubConsultant={getSubConsultantData} workTypeList={workStatList} />,
        workstages: <AddWorkStat getData={getWorkStatsData} />,
        worktypes: <AddWorkType getData={getWorkTypeData} />,
    };

    return (
        <>
            <Dashboardnavbar name="Settings" url="Settings" />

            <div className="content-tabs" style={{ width: "95%" }}>

                {/* Tab Bar */}
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #e0e0e0",
                    background: "#fff",
                    borderRadius: "12px 12px 0 0",
                    padding: "0 24px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                }}>
                    <div style={{ display: "flex" }}>
                        {tabs.map(tab => (
                            <button
                                key={tab.key}
                                onClick={() => setActiveTab(tab.key)}
                                style={{
                                    background: "none",
                                    border: "none",
                                    borderBottom: activeTab === tab.key
                                        ? "2px solid #1a5fa8"
                                        : "2px solid transparent",
                                    color: activeTab === tab.key ? "#1a5fa8" : "#aaa",
                                    fontWeight: activeTab === tab.key ? "500" : "400",
                                    fontSize: "14px",
                                    padding: "16px 28px",
                                    cursor: "pointer",
                                    marginBottom: "-1px",
                                    transition: "all 0.15s",
                                    letterSpacing: "0.01em",
                                }}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>
                    <div>{addButtonMap[activeTab]}</div>
                </div>
                {/* Tab Content */}
                <div style={{
                    background: "#fff",
                    borderRadius: "0 0 12px 12px",
                    border: "1px solid #e0e0e0",
                    borderTop: "none",
                    minHeight: "70vh",
                }}>
                    {activeTab === 'sectors' && (
                        <Consultant
                            getData={getSubConsultantData}
                            list={subConsultantList}
                            buffering={buffering}
                            workTypeList={workStatList}
                        />
                    )}
                    {activeTab === 'workstages' && (
                        <WorkStat
                            getData={getWorkStatsData}
                            list={workStatList}
                            buffering={bufferingForWorkStat}
                        />
                    )}
                    {activeTab === 'worktypes' && (
                        <WorkTypes
                            getData={getWorkTypeData}
                            list={workTypeList}
                            buffering={bufferingForWorkType}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default ConsultantManagement;